<section class="cierre-administrativo container py-3">
    <h3 *ngIf="id && !expediente">Expediente: {{ id }}</h3>

    <div class="mb-3">
        <button class="btn btn-outline-secondary btn-sm" [routerLink]="['/administracion/dictamen']">
            <i class="bi bi-arrow-left"></i> Volver al listado
        </button>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2">Cargando información del expediente...</p>
    </div>

    <!-- Details similar to CasoDictamen -->
    <div class="row mb-4" *ngIf="expediente && !isLoading">
        <div class="col-md-6">
            <div class="card h-100">
                <div class="card-header bg-light">
                    <h6 class="mb-0">Detalles del Funcionario</h6>
                </div>
                <div class="card-body">
                    <p class="mb-1"><strong>Nombre:</strong> {{ expediente.exp_nombre_fun }} {{
                        expediente.exp_apellido_paterno_fun }} {{ expediente.exp_apellido_materno_fun }}</p>
                    <p class="mb-1"><strong>RUT:</strong> {{ expediente.exp_rut_fun }}</p>
                    <p class="mb-1"><strong>ID Expediente:</strong> {{ expediente.exp_id }}</p>
                    <p class="mb-1"><strong>Estado Actual:</strong> <span class="badge badge-primary">{{
                            expediente.eex_nombre }}</span></p>
                    <p class="mb-1"><strong>Fecha Ingreso:</strong> {{ expediente.exp_fecha_ingreso | date:'dd/MM/yyyy'
                        }}</p>
                    <p class="mb-0" *ngIf="expediente.exp_observaciones"><strong>Observaciones:</strong> {{
                        expediente.exp_observaciones }}</p>
                </div>
            </div>
        </div>

        <div class="col-md-6" *ngIf="institucion">
            <div class="card h-100">
                <div class="card-header bg-light">
                    <h6 class="mb-0">Institución Solicitante</h6>
                </div>
                <div class="card-body">
                    <p class="mb-1"><strong>Nombre:</strong> {{ institucion.ins_nombre }}</p>
                    <p class="mb-1"><strong>RUT:</strong> {{ institucion.ins_rut }}</p>
                    <p class="mb-1"><strong>Email Notificación:</strong> {{ institucion.ins_correo_notificacion }}</p>
                    <p class="mb-0"><strong>Dirección:</strong> {{ institucion.ins_direccion }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Documents -->
    <div *ngIf="documentos && documentos.length > 0 && !isLoading" class="mb-4">
        <h6>Documentos asociados</h6>
        <ul class="list-group">
            <li *ngFor="let d of documentos" class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                    <div>{{ d.name }}</div>
                    <small class="text-muted" *ngIf="d.type === 'zip'">(Este archivo es un ZIP — debe descargarse para
                        ver su contenido)</small>
                </div>
                <div>
                    <button *ngIf="d.type === 'pdf'" class="btn btn-sm btn-secondary"
                        (click)="viewDocumento(d)">Ver</button>
                    <button *ngIf="d.type === 'zip'" class="btn btn-sm btn-outline-secondary"
                        (click)="viewDocumento(d)">Descargar</button>
                </div>
            </li>
        </ul>
    </div>

    <!-- Cierre Administrativo Form -->
    <div class="card border-danger" *ngIf="expediente && !isLoading">
        <div class="card-header bg-danger text-white">
            <h5 class="mb-0">Formulario de Cierre Administrativo</h5>
        </div>
        <div class="card-body">
            <div class="alert alert-warning">
                <i class="bi bi-exclamation-triangle-fill"></i> Atención: Esta acción dará por finalizado el proceso del
                expediente y no podrá ser revertida. Se generará un informe de cierre administrativo.
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="form-group mb-3">
                    <label for="motivo" class="font-weight-bold">Motivo de Cierre <span
                            class="text-danger">*</span></label>
                    <select class="form-control" id="motivo" formControlName="motivo">
                        <option value="">-- Seleccione un motivo --</option>
                        <option *ngFor="let m of motivosCierre" [value]="m">{{ m }}</option>
                    </select>
                    <div *ngIf="form.get('motivo')?.invalid && form.get('motivo')?.touched"
                        class="text-danger small mt-1">
                        El motivo es obligatorio.
                    </div>
                </div>

                <div class="form-group mb-4">
                    <label for="observaciones" class="font-weight-bold">Observaciones</label>
                    <textarea class="form-control" id="observaciones" rows="4" formControlName="observaciones"
                        placeholder="Ingrese detalles adicionales..."></textarea>
                    <small class="text-muted"
                        *ngIf="form.get('motivo')?.value === 'La Institución desiste del trámite'">
                        * Obligatorio para el motivo seleccionado.
                    </small>
                </div>

                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-secondary mr-2"
                        [routerLink]="['/administracion/dictamen']">Cancelar</button>
                    <button type="submit" class="btn btn-danger" [disabled]="isProcessing || form.invalid">
                        <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Confirmar Cierre Administrativo
                    </button>
                </div>

            </form>
        </div>
    </div>

</section>